import { useQuery } from 'react-query'
import { reportsAPI } from '../utils/api'

export const useAccountStatusReport = (params = {}) => {
  // Clean params - remove null/empty values and format dates
  const cleanParams = Object.entries(params).reduce((acc, [key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      // Format dates as ISO strings for API
      if (key === 'startDate' || key === 'endDate') {
        acc[key] = value instanceof Date ? value.toISOString() : value;
      } else {
        acc[key] = value;
      }
    }
    return acc;
  }, {});

  return useQuery(
    ['reports', 'account-status', cleanParams],
    () => reportsAPI.getAccountStatus(cleanParams).then(res => res.data),
    {
      enabled: true, // Always enabled - let backend handle empty filters
      staleTime: 5 * 60 * 1000, // 5 minutes
    }
  )
}

export const useClientAccountStatusReport = (clientId, params = {}) => {
  // Clean params - remove null/empty values and format dates
  const cleanParams = Object.entries(params).reduce((acc, [key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      // Format dates as ISO strings for API
      if (key === 'startDate' || key === 'endDate') {
        acc[key] = value instanceof Date ? value.toISOString() : value;
      } else {
        acc[key] = value;
      }
    }
    return acc;
  }, {});

  return useQuery(
    ['reports', 'client-account-status', clientId, cleanParams],
    () => reportsAPI.getClientAccountStatus(clientId, cleanParams).then(res => res.data),
    {
      enabled: !!clientId,
      staleTime: 5 * 60 * 1000, // 5 minutes
    }
  )
}

export const useMonthlySalesReport = (params = {}) => {
  // Clean params - remove null/empty values and format dates
  const cleanParams = Object.entries(params).reduce((acc, [key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      // Format dates as ISO strings for API
      if (key === 'startDate' || key === 'endDate') {
        acc[key] = value instanceof Date ? value.toISOString() : value;
      } else {
        acc[key] = value;
      }
    }
    return acc;
  }, {});

  return useQuery(
    ['reports', 'monthly-sales', cleanParams],
    () => reportsAPI.getMonthlySales(cleanParams).then(res => res.data),
    {
      staleTime: 5 * 60 * 1000, // 5 minutes
    }
  )
}

export const useTopDebtorsReport = (params = {}) => {
  return useQuery(
    ['reports', 'top-debtors', params],
    () => reportsAPI.getTopDebtors({ params }).then(res => res.data),
    {
      staleTime: 5 * 60 * 1000, // 5 minutes
    }
  )
}

export const useAgingReport = (params = {}) => {
  return useQuery(
    ['reports', 'aging', params],
    () => reportsAPI.getAging({ params }).then(res => res.data),
    {
      staleTime: 5 * 60 * 1000, // 5 minutes
    }
  )
}
